export default [
    {
        key: 'errorMessage',
        value: ''
    },
    {
        key: 'firstNameError',
        value: ''
    },
    {
        key: 'lastNameError',
        value: ''
    },
    {
        key: 'emailError',
        value: ''
    },
    {
        key: 'mobileNumberError',
        value: ''
    },
    {
        key: 'passwordError',
        value: ''
    }
];